import React from 'react'
import { useTranslation } from 'react-i18next'

const ReplyView = ({ item, handleView }) => {
  const { t } = useTranslation()

  return (
    <>
      <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative w-auto my-6 mx-auto max-w-3xl'>
          <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
            <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[762px]'>
              <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
                <h3 className='text-xl font-semibold'>{t('VIEW')}</h3>
                <button
                  className=' ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                  onClick={() => handleView(false)}
                >
                  <span
                    className=' text-[#B8BBBF]  text-4xl '
                    onClick={() => handleView()}
                    title='Close'
                  >
                    ×
                  </span>
                </button>
              </div>
              <div className='relative p-6 flex-auto'>
                <div className='grid'>
                  <div className='sm:p-4 p-8  bg-slate-200 rounded-md mb-3'>
                    <div className='relative z-0 mb-1 w-full group'>
                      <strong>Description:</strong>
                      <h6>{item.description || ''}</h6>
                    </div>
                  </div>
                  {item?.adminReply ? <div className='sm:p-4 p-8  bg-slate-200 rounded-md mb-3'>
                    <div className='relative z-0 w-full group'>
                      <strong>Admin reply:</strong>
                      <h6>{item.adminReply || ''}</h6>
                    </div>
                  </div> : null}
                </div>
              </div>
              <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
                <button
                  className='text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150'
                  type='button'
                  onClick={() => handleView()}
                >
                  {t('O_BACK')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black' />
    </>
  )
}

export default ReplyView
